<template>
	<div class="description-wrapper">
<!--		<img src="@/assets/logo.svg" alt="">-->
		<h3 class="subtitle">
			Instant Cameras
		</h3>
		<h2 class="title">
			Polaroid Go
		</h2>
		<p class="paragraph">
			Portable. Wearable. Create anywhere-able. Get the world's tiniest instant analog camera.
		</p>
	</div>
</template>

<script>
export default {
	name: 'Description',
};
</script>

<style lang="sass" scoped>
.description-wrapper
	max-width: 450px

.subtitle
	margin: 0 0 -7px 0

	font-size: 18px
	line-height: 25px

	font-weight: 600

	letter-spacing: -0.02em

	@media (max-width: 650px)
		display: none

.title
	margin: 0 0 6px 0

	font-size: 54px
	line-height: 75px

	font-weight: 600

	letter-spacing: -0.015em

	@media (max-width: 650px)
		font-size: 48px
		line-height: 1
		margin: 0

.paragraph
	margin: 0

	font-size: 16px
	line-height: 22px

	font-weight: 400

	letter-spacing: -0.015em

	@media (max-width: 650px)
		display: none
</style>
